const DocumentIcon = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="currentColor"
    className="h-5 w-5"
  >
    <path d="M22.5,18c0-.46-.089-.895-.218-1.312l1.417-.816-.999-1.732-1.41,.813c-.605-.652-1.393-1.126-2.289-1.331v-1.621h-2v1.621c-.896,.205-1.685,.678-2.289,1.331l-1.41-.813-.999,1.732,1.417,.816c-.129,.418-.218,.853-.218,1.312s.089,.895,.218,1.312l-1.417,.816,.999,1.732,1.41-.813c.605,.652,1.393,1.126,2.289,1.331v1.621h2v-1.621c.896-.205,1.685-.678,2.289-1.331l1.41,.813,.999-1.732-1.417-.816c.129-.418,.218-.853,.218-1.312Zm-4.5,2.5c-1.378,0-2.5-1.121-2.5-2.5s1.122-2.5,2.5-2.5,2.5,1.121,2.5,2.5-1.122,2.5-2.5,2.5Zm-4-11.5H4v-2H14v2Zm-2.24,4H4v-2H14v.079c-.861,.499-1.62,1.149-2.24,1.921Zm-7.76,2h6.587c-.256,.631-.431,1.301-.518,2H4v-2Zm7.079,7c.437,.754,.992,1.428,1.642,2H3c-1.654,0-3-1.346-3-3V2H5.171c.413-1.164,1.525-2,2.829-2h2c1.304,0,2.416,.836,2.829,2h5.171V10c-.692,0-1.36,.097-2,.262V4h-5v-1c0-.552-.449-1-1-1h-2c-.551,0-1,.448-1,1v1H2V21c0,.552,.449,1,1,1H11.079Z" />
  </svg>
);

export default DocumentIcon;
